module.exports = __webpack_public_path__ + "static/media/04-ic-05@3x.223863c2.webp";